import { apiAction } from "../models/requests";
import { USER_ID } from "../constants/Constants";

const appendTokenName = (data) => {
    return data;
};

export function getAdminProfile() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user = {"user_id": USER_ID};   
    appendTokenName(data); 
    return apiAction({
        types: ["GET_ADMIN_PROFILE_REQUESTED", "GET_ADMIN_PROFILE_SUCCESS", "GET_ADMIN_PROFILE_FAILED"],
        method: "POST",
        path: "admin/get_user",
        body: data
    });
}

export function setAdminPassword(password) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.current_password = password.password,
    data.new_password =  password.confirmPassword;
    data.set_two_factor = password.set_two_factor;
    appendTokenName(data); 
    return apiAction({
        types: ["SET_ADMIN_PASSWORD_REQUESTED", "SET_ADMIN_PASSWORD_SUCCESS", "SET_ADMIN_PASSWORD_FAILED"],
        method: "POST",
        path: "admin/set_password",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionAdminProfile.js